import Vue from 'vue';
import i18n from '@/i18n'
Vue.filter('pricePrefixAbbr', function (value) {
    if (!value) {
      return ''
    } 
    
    switch(value.toLowerCase()){
        case i18n.t('general.per-person-only'):
            return i18n.t('general.per-person-only-abrev');
        default:
            return value;
    }
})